var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolkswagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.744 192.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.744v192.744H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.336 2.865c-51.663 0-93.543 41.882-93.543 93.543 0 51.662 41.881 93.543 93.543 93.543 51.66 0 93.543-41.881 93.543-93.543 0-51.66-41.883-93.543-93.543-93.543zm0 178.699c-47.031 0-85.156-38.125-85.156-85.156 0-47.029 38.125-85.155 85.156-85.155 47.029 0 85.156 38.126 85.156 85.155 0 47.031-38.127 85.156-85.156 85.156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.692 32.786a66.308 66.308 0 0 1 18.644-2.657c6.465 0 12.715.926 18.623 2.652l-18.623 41.28-18.644-41.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.914 40.477a66.695 66.695 0 0 1 17.957 16.847l-30.566 67.64-11.795-26.227H85.162l-11.794 26.226-30.522-67.702a66.635 66.635 0 0 1 17.909-16.783l24.407 54.146h22.424l24.328-54.147zM32.296 79.254a66.384 66.384 0 0 0-2.241 17.154c0 25.975 14.939 48.458 36.694 59.329L32.296 79.254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 160.12a66.268 66.268 0 0 0 18.336 2.569c6.354 0 12.498-.895 18.314-2.562l-18.314-40.673L78 160.12zM125.92 155.737c21.756-10.871 36.695-33.354 36.695-59.329 0-5.88-.766-11.581-2.201-17.009l-34.494 76.338z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagen);
export default __webpack_public_path__ + "static/media/volkswagen.a1048b922bf30958281713a6e9ce3407.svg";
export { ForwardRef as ReactComponent };